export const AVAILABILITY_REQUEST = "AVAILABILITY_REQUEST";
export const AVAILABILITY_SUCCESS = "AVAILABILITY_SUCCESS";
export const AVAILABILITY_FAIL = "AVAILABILITY_FAIL";

export const RESERVATION_CREATE_REQUEST = "RESERVATION_CREATE_REQUEST";
export const RESERVATION_CREATE_SUCCESS = "RESERVATION_CREATE_SUCCESS";
export const RESERVATION_CREATE_FAIL = "RESERVATION_CREATE_FAIL";

export const EVENTS_LIST_REQUEST = "EVENTS_LIST_REQUEST";
export const EVENTS_LIST_SUCCESS = "EVENTS_LIST_SUCCESS";
export const EVENTS_LIST_FAIL = "EVENTS_LIST_FAIL";

export const EVENT_DETAILS_REQUEST = "EVENT_DETAILS_REQUEST";
export const EVENT_DETAILS_SUCCESS = "EVENT_DETAILS_SUCCESS";
export const EVENT_DETAILS_FAIL = "EVENT_DETAILS_FAIL";

export const EVENT_RESERVE_REQUEST = "EVENT_RESERVE_REQUEST";
export const EVENT_RESERVE_SUCCESS = "EVENT_RESERVE_SUCCESS";
export const EVENT_RESERVE_FAIL = "EVENT_RESERVE_FAIL";

export const RESERVATION_LOOKUP_REQUEST = "RESERVATION_LOOKUP_REQUEST";
export const RESERVATION_LOOKUP_SUCCESS = "RESERVATION_LOOKUP_SUCCESS";
export const RESERVATION_LOOKUP_FAIL = "RESERVATION_LOOKUP_FAIL";

export const RESERVATION_CANCEL_REQUEST = "RESERVATION_CANCEL_REQUEST";
export const RESERVATION_CANCEL_SUCCESS = "RESERVATION_CANCEL_SUCCESS";
export const RESERVATION_CANCEL_FAIL = "RESERVATION_CANCEL_FAIL";
